<template>
  <div id="searchResultsPage">
    <header>
      <search :focus="true" :text="emptyText" @onSearch="onSearch" @searchInput="searchInput"></search>
    </header>
    <main class="page-main">
      <van-list
          v-if="!showEmpty"
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="onLoad"
      >
        <listItem :recipesList="recipesList" @handleDetails="handleDetails"></listItem>
        <template #finished>
          <img
              class="icon"
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
          />
          我们会加油更新的 么么哒~
          <img
              class="icon"
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
          />
        </template>
      </van-list>
      <emptyList v-if="showEmpty" :emptyText="keyword"></emptyList>
    </main>
  </div>
</template>

<script>
import {initClassTop, setClassTop} from "@/assets/js/common"
import search from "@/components/contents/babyFeeding/search";
import mixins from "@/minxs/babyFeeding"
import listItem from "@/components/contents/babyFeeding/recipes/listItem"
// 数据为空组件
import emptyList from "@/components/contents/babyFeeding/recipes/emptyList.vue";
import {BuiedPointClick_Fn, Exposurer_feeding_Fn} from "@assets/js/BuriedPointEvent";

export default {
  name: "searchResultsPage",
  mixins: [mixins],
  data() {
    return {
      searchObj: {},// 搜索条件
      emptyText: this.$route.query.searchText || "",// 搜索的数据
      keyword: this.$route.query.searchText,
      babyFeedYue: JSON.parse(localStorage.getItem('babyFeedYue')) || {}
    }
  },
  activated() {
    setClassTop('page-main')
  },
  beforeRouteLeave(to, from, next) {
    initClassTop('page-main')
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit("plusIncludes", 'searchResultsPage')
    })
  },
  mounted() {
    Exposurer_feeding_Fn.observe('xmhh5_bbsp_allpageview', '.baby_feed_Index', false, {
      xmhh5_bbsp_pagename: '食谱搜索结果',
      xmhh5_bbsp_monthage: this.babyFeedYue?.name || "",
      xmhh5_bbsp_title: ""
    })
  },
  methods: {
    handleDetails(value) {
      console.log(value, 'xmhh5_bbsp_serchresult_click')
      BuiedPointClick_Fn('xmhh5_bbsp_serchresult_click', {
        xmhh5_bbsp_title: value.oldTitle ? value.oldTitle : value.title
      })
      // this.$router.push({path: "/babyFeedDetails/" + 75})
    },
    // 搜索
    onSearch(value) {
      this.keyword = value
      BuiedPointClick_Fn('xmhh5_bbsp_serch_click', {
        xmhh5_bbsp_searchword: value
      })
      this.getSearchFeedRecipes({
        keyword: value,
      })
      // this.getBabyFeedList()
    },
    // 输入内容
    searchInput(value) {
      if (value == '') {
        this.$router.replace('/searchRecipes')
      } else {
        this.emptyText = value
      }
    },
    onLoad() {
      setTimeout(() => {
        console.log(this.total > this.recipesList.length, 'this.total > this.recipesList.length')
        if (this.recipesList.length) {
          if (this.total > this.recipesList.length) {
            this.pageNum = this.pageNum + 1
            this.getSearchFeedRecipes({
              keyword: value,
            })
          } else {
            this.finished = true
          }
        }

      }, 500)
    }
  },
  created() {

    BuiedPointClick_Fn('xmhh5_bbsp_serch_click', {
      xmhh5_bbsp_searchword: this.$route.query.searchText
    })
    console.log(this.$route.query.searchText, 'searchText')
  },
  watch: {
    "$route.query": {
      handler(newValue) {
        this.searchObj = {...newValue}
        this.emptyText = newValue.searchText
        this.keyword = newValue.searchText
        if (newValue.searchText && newValue.searchText !== '') {
          this.getSearchFeedRecipes({
            keyword: newValue.searchText
          })
        }

        console.log(newValue, 'newValue')
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    search,
    emptyList,
    listItem
  }
}
</script>

<style lang="less" scoped>
#searchResultsPage {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  header {
    height: 66px;
    background: #fff;
    padding-bottom: 10px;
  }

  main {
    flex: 1;
    overflow: scroll;
    background: #fff;

    ::v-deep .van-list__finished-text {
      background: #fff;
    }
  }
}
</style>